module.exports = __webpack_public_path__ + "static/media/logo.a91dec99.svg";